import { Button, Icon, Intent, Position, Tooltip } from "@blueprintjs/core"
import { da } from "date-fns/locale"
import { useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import Shortcode from "src/libs/useful/shortcode"
import { __ } from "src/libs/utilities"
import { ILandingContent, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import CheckboxHandler from "./CheckboxHandler"


interface ISingleMeatLayer {
    data: ILandingContent
    sectionId: ID
}
const SingleMeatLayer = ({data, ...props}: ISingleMeatLayer) : JSX.Element => {
    const { currentLanding, selectedMeat }	= useLandingStore((state: ILandingStore) => state) 

    const onRmv = () => {
        const cr = {
            ...currentLanding,
            sections: [
                ...currentLanding.sections.map((s: ILandingSection) => {
                    if(s.id === props.sectionId){
                        return {
                            ...s,
                            data: s.data.filter(meat => meat.id !== data.id )
                        }
                    }
                    return s
                })
            ]
        }
        useLandingStore.setState({ currentLanding : cr})
    }
    const onSelect = () => {
        const landingCont = getLandingContainer()
        const element = landingCont.querySelector( `.landing-section-container.landing-gap[id="${props.sectionId.toString()}"]` )
        if(!!element) { 
            const lScroll = landingCont.scrollTop
            landingCont.scrollTo({
                behavior: 'smooth',
                top: lScroll + element.getBoundingClientRect().top,
            })
        } 
        useLandingStore.setState({ selectedMeat : data.id, selectedLayer: props.sectionId })
    }

    const onEdit = () => {
        useLandingStore.setState({ 
            curEditModal: {
                ...data, 
                sectionId: props.sectionId, 
                currentEditType: SELECT_TYPE.CONTENT,
            }            
        })
    }
    const onCheck = () => {

    }

    
    return <div className={`panel-list-button pl-0 pr-1 py-0 ${ selectedMeat === data.id ? "meat-active" : "" } `} >
        <Icon icon="drag-handle-vertical" className="pl-1 pr-1 pe-surface4 hover " size={13}/>
        <CheckboxHandler 
            onCheck={ onCheck } 
            type={ SELECT_TYPE.CONTENT } 
            item={ data } 
            sectionId={ props.sectionId } 
        />
        <img src={components()[data.type].icon} alt="" height={12} className="panel-icon pr-1" />
        <Shortcode 
            className="small text-light text-overflow flex-grow-100 px-1 py-2" content={ __( components()[ data.type ].title ) + " <span class='opacity_5 small'>#" + data.id + "</span>" } 
            onClick={onSelect}
        /> 
        <Tooltip
            content={<div className="small">{__("Edit meat")}</div>}
            intent={Intent.PRIMARY}
            position={Position.TOP_RIGHT}
            compact
        >
            <Button variant="minimal" onClick={onEdit} > 
                <Icon icon="edit" size={9} color="#FFFFFF" />
            </Button>
        </Tooltip>
        <Tooltip
            content={<div className="small">{__("Hide | show meat")}</div>}
            intent={Intent.PRIMARY}
            position={Position.TOP_RIGHT}
            compact
        >
            <Button variant="minimal" >
                <i className="far fa-eye"></i>
            </Button>
        </Tooltip>
        <Tooltip
            content={<div className="small">{__("Remove meat")}</div>}
            intent={Intent.PRIMARY}
            position={Position.TOP_RIGHT}
            compact
        >
            <Button variant="minimal" onClick={onRmv} >
                <i className={ "fas fa-trash"  }></i> 
            </Button>
        </Tooltip>
    </div>
}

export default SingleMeatLayer